const state = {
    showpost : {
        dialog : false
    },
    showreply : {
        replydialog: false
    },

    // store selected filtered stats 
    stateId : [],
    

    stateDoneClicked : "false",
    
    startDate : "",
    endDate : "",
    topicsId : [],

    croplistId : [],
    selectedQuery : [],
}

const mutations = {
    TOGGLE_DIALOG:(state, value) =>{
        state.showpost.dialog = !state.showpost.dialog
    },
    TOGGLE_REPLY_DIALOG:(state, value) =>{
        state.showreply.replydialog = !state.showreply.replydialog
    },
    // for location (states)
    TOGGLE_LOCATION_DONE_BTN : (state, value) => {
        console.log("klnewgwoigji2329tu92u4t0i230tu30923095823975239");
        state.stateDoneClicked = "true"
        console.log("state.stateDoneClicked", state.stateDoneClicked);
    },

    ADD_STATE: (state, value) => {
        console.log("ADD STATE CLICKED +++++++++++++++++++++++++++=");
        state.stateId = []
        for(var i = 0; i<value.stateid.length; i++){
            state.stateId.push(value.stateid[i])
        }
    },  

    REMOVE_STATE:(state, value) =>{
        console.log("REMOVEED CLICKDE");
        state.stateId = [];
    },

    REMOVE_STATE_ID: (state, value) => {
        console.log("STATE BEFORE RE ID", state.stateId);
        console.log("STORE VAL", value);
        for(var i = 0; i<value.stateid.length; i++){
            console.log(value.stateid[i]);
            state.stateId = state.stateId.filter(element => ![value.stateid[i]].includes(element)); 
        }
        console.log("STATE AFTER RE ID", state.stateId);
    },

    // dates
    ADDSTART_DATE:(state, value)=>{
        state.startDate = value
        console.log(value);
    },
    ADDEND_DATE:(state, value)=>{
        state.endDate = value
        console.log("END_DATE_STORE", value);
    },
    REMOVE_START_DATE:(state, value)=>{
        state.startDate = ""
    },
    REMOVE_END_DATE:(state, value)=>{
        state.endDate = ""
    },

    // topics
    ADD_TOPICS: (state, value) => {
        state.topicsId = []
        console.log("VALUE", value);
        for(var i = 0; i<value.topics.length; i++){
            state.topicsId.push(value.topics[i])
        }
    },  
    REMOVE_TOPICS_ID: (state, value) => {
        console.log("TOPICS BEFORE RE ID", state.topicsId);
        console.log("STORE VAL", value);
        for(var i = 0; i<value.topicsId.length; i++){
            console.log(value.topicsId[i]);
            state.topicsId = state.topicsId.filter(element => ![value.topicsId[i]].includes(element)); 
        }
        console.log("TOPICS AFTER RE ID", state.topicsId);
    },
    REMOVE_TOPICS:(state, value) =>{
        console.log("REMOVE TOPICS CLICKED");
        state.topicsId = [];
    },   
    
    // crops
    ADD_CROPS: (state, value) => {
        state.croplistId = []
        value.crops.map(item => {
            console.log(item);
            state.croplistId.push(item)
        })
    }, 
    REMOVE_CROPS:(state, value) =>{
        state.croplistId = [];
    },

    ADD_QUERY: (state, value) => {
        console.log("VALUE", value);
        state.selectedQuery = []
        value.stateid.map(item => {
            state.selectedQuery.push(item)
        })
    },
    REMOVE_SELECTED_QUERY : (state, value) =>{
        state.selectedQuery = []
    }
}
const actions = {
    toggledialog({ commit } ) {
        commit("TOGGLE_DIALOG");
    },   
    toggledreplyialog({ commit } ) {
        commit("TOGGLE_REPLY_DIALOG");
    },

    // for state
    togglelocationdonebtn({ commit } ) {
        commit("TOGGLE_LOCATION_DONE_BTN");
    },     
    addstatedata({ commit }, payload ) {
        commit("ADD_STATE", payload);
    },  
    removestateid({ commit } ) {
        commit("REMOVE_STATE");
    },  
    removesomestateid({ commit }, payload ) {
        commit("REMOVE_STATE_ID", payload);
    },    

    // for date
    addstartdate({ commit }, payload ){
        commit("ADDSTART_DATE", payload)
    },
    addenddate({ commit }, payload ){
        commit("ADDEND_DATE", payload)
    },
    removestartdate({ commit }, payload ){
        commit("REMOVE_START_DATE")
    },
    removeenddate({ commit }, payload ){
        commit("REMOVE_END_DATE")
    },

    //for topics
    addtopics({ commit }, payload ) {
        console.log("PAYLOAD", payload);
        commit("ADD_TOPICS", payload);
    }, 
    removealltopics({ commit }, payload ){
        commit("REMOVE_TOPICS", payload);
    },

    // for crops
    addcrops({ commit }, payload ) {
        commit("ADD_CROPS", payload);
    },
    removeallcrops({ commit }, payload ){
        commit("REMOVE_CROPS", payload);
    },

    // for queries
    addSelectedQuery({ commit }, payload ) {
        commit("ADD_QUERY", payload);
    }, 
    removeSelectedQuery({ commit }, payload){
        commit("REMOVE_SELECTED_QUERY", payload)
    }
}

const getters = {
    GET_POST_DETAILS: (state) => state.showpost,
    GET_REPLY_DETAILS: (state) => state.showreply,

    GET_STATE_ID: (state) => state.stateId,

    GET_LOCATION_DONE_STATE : (state) => state.stateDoneClicked,
    GET_STARTDATE : (state) => state.startDate,
    GET_ENDDATE : (state) => state.endDate,
    GET_SELECTED_TOPICS : (state) => state.topicsId,
    GET_SELECTED_CROPS : (state) => state.croplistId,
    GET_SELECTED_QUERY : (state) => state.selectedQuery,

    getSelectedQueries : state => state.selectedQuery
}

export default{
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}

